export interface Stock {

    codigo: number;
    nombre: string;
    descripcion: string;
    entrega: string;
    articulo: string;
    stockMostrar: string;
    stockPendiente: number;
    stockResA: number;
    stockRes: number;
    fechaHoraCorte: string;
    fechaCorte: string;
    horaCorte: string;

    colorEntrega: number;
}

export class StockHelper {

    static create(): Stock {
        return {
            codigo: 0,
            nombre: '',
            descripcion: '',
            entrega: '',
            articulo: '',
            stockMostrar: '',
            stockPendiente: 0,
            stockResA: 0,
            stockRes: 0,
            fechaHoraCorte: '',
            fechaCorte: '',
            horaCorte: '',
            colorEntrega: 0
        };
    }

    static transformFromApi(apiObject: Object) {
        const obj = StockHelper.create();
        obj.codigo = apiObject['ALCDG'] ? apiObject['ALCDG'] : 0;
        obj.nombre = apiObject['ALNBR'] ? apiObject['ALNBR'] : '';
        obj.descripcion = apiObject['DESCRIP'] ? apiObject['DESCRIP'] : '';
        obj.entrega = apiObject['ENTREGA'] ? apiObject['ENTREGA'] : '';
        obj.articulo = apiObject['START'] ? apiObject['START'] : '';
        obj.stockMostrar = apiObject['STDIS'] ? apiObject['STDIS'] : 0;
        obj.stockPendiente = apiObject['STPTE'] ? apiObject['STPTE'] : 0;
        obj.stockResA = apiObject['STREA'] ? apiObject['STREA'] : 0;
        obj.stockRes = apiObject['STRES'] ? apiObject['STRES'] : 0;
        obj.fechaHoraCorte =  apiObject['FECHAHORACORTE'] ? apiObject['FECHAHORACORTE'] : '';

        obj.colorEntrega = apiObject['COLORENTREGA'] ? apiObject['COLORENTREGA'] : 0;

        if (obj.fechaHoraCorte && obj.fechaHoraCorte !== '') {
            let a = obj.fechaHoraCorte.split(' ');
            let b = a[0].split('/');
            obj.fechaHoraCorte = b[2] + '-' + b[1] + '-' + b[0] + ' ' + a[1];

            obj.fechaCorte = b[2] + '-' + b[1] + '-' + b[0];
            obj.horaCorte  = a[1];
        }


        return obj;
    }
}
